angular.module("acl.visualizer.fieldFormatOptions", [
  "acl.visualizer.dataFilter",
  "acl.visualizer.dataTable",
  "acl.visualizer.model.field",
  "templates-visualizer",
]);
